import { getCurrencySymbol } from "../../utils/formatNumber"

//-------------------------------------------------------------------
const parsePriceDailyData = (materialPrices, availableCurrencies) => {
  return materialPrices.map(p => {
    const dt = new Date(p.dateObj)
    let price = {
      dt: dt.getTime(),
    }
    for (const currency of availableCurrencies)
      price[currency.id] = p[currency.id]
    return price
  })
}

//-------------------------------------------------------------------
const calculateAveragePrices = (availableCurrencies, objContainer) => {
  return availableCurrencies.map((ac, idx) => {
    return objContainer.sumPrices[idx] / objContainer.amountSummed
  })
}

//-------------------------------------------------------------------
const calculateSumPrices = (availableCurrencies, objContainer, prices) => {
  return availableCurrencies.map((ac, idx) => {
    return objContainer.sumPrices[idx] + prices[ac.id]
  })
}

//-------------------------------------------------------------------
const organisePricesByMonth = (prices, availableCurrencies) => {
  if (!prices.length) return []

  const pricesByMonth = []
  const prices0dt = new Date(prices[0].dateObj)
  let currentMonthInfo = {
    sumPrices: availableCurrencies.map((ac, idx) => prices[0][ac.id]),
    amountSummed: 1,
    avgPrices: availableCurrencies.map((ac, idx) => 0.0),
    month: prices0dt.getMonth(),
    year: prices0dt.getFullYear(),
  }
  let pending = true
  for (let i = 1; i < prices.length; i++) {
    const pricedt = new Date(prices[i].dateObj)
    const currMonth = pricedt.getMonth()
    const currYear = pricedt.getFullYear()
    if (currMonth !== currentMonthInfo.month) {
      currentMonthInfo.avgPrices = calculateAveragePrices(
        availableCurrencies,
        currentMonthInfo
      )
      pricesByMonth.push(JSON.parse(JSON.stringify(currentMonthInfo)))

      currentMonthInfo = {
        sumPrices: availableCurrencies.map((ac, idx) => prices[i][ac.id]),
        amountSummed: 1,
        avgPrices: availableCurrencies.map((ac, idx) => 0.0),
        month: currMonth,
        year: currYear,
      }
      pending = false
    } else {
      currentMonthInfo.sumPrices = calculateSumPrices(
        availableCurrencies,
        currentMonthInfo,
        prices[i]
      )
      currentMonthInfo.amountSummed++
      pending = true
    }
  }
  if (pending) {
    currentMonthInfo.avgPrices = calculateAveragePrices(
      availableCurrencies,
      currentMonthInfo
    )
    pricesByMonth.push(JSON.parse(JSON.stringify(currentMonthInfo)))
  }

  return pricesByMonth
}

//-------------------------------------------------------------------
const parsePriceMonthlyData = (materialPrices, availableCurrencies) => {
  const pricesByMonth = organisePricesByMonth(
    materialPrices,
    availableCurrencies
  )
  return pricesByMonth.map(p => {
    const dt = new Date(parseInt(p.year), parseInt(p.month), 1)
    let price = {
      dt: dt.getTime(),
    }
    for (let idx = 0; idx < availableCurrencies.length; idx++)
      price[availableCurrencies[idx].id] = p.avgPrices[idx]
    return price
  })
}

//-------------------------------------------------------------------
const organisePricesByYear = (prices, availableCurrencies) => {
  if (!prices.length) return []

  const pricesByYear = []
  const prices0dt = new Date(prices[0].dateObj)
  let currentYearInfo = {
    sumPrices: availableCurrencies.map((ac, idx) => prices[0][ac.id]),
    amountSummed: 1,
    avgPrices: availableCurrencies.map((ac, idx) => 0.0),
    year: prices0dt.getFullYear(),
  }
  let pending = true
  for (let i = 1; i < prices.length; i++) {
    const pricedt = new Date(prices[i].dateObj)
    const currYear = pricedt.getFullYear()
    if (currYear !== currentYearInfo.year) {
      currentYearInfo.avgPrices = calculateAveragePrices(
        availableCurrencies,
        currentYearInfo
      )
      pricesByYear.push(JSON.parse(JSON.stringify(currentYearInfo)))

      currentYearInfo = {
        sumPrices: availableCurrencies.map((ac, idx) => prices[i][ac.id]),
        amountSummed: 1,
        avgPrices: availableCurrencies.map((ac, idx) => 0.0),
        year: currYear,
      }
      pending = false
    } else {
      currentYearInfo.sumPrices = calculateSumPrices(
        availableCurrencies,
        currentYearInfo,
        prices[i]
      )
      currentYearInfo.amountSummed++
      pending = true
    }
  }
  if (pending) {
    currentYearInfo.avgPrices = calculateAveragePrices(
      availableCurrencies,
      currentYearInfo
    )
    pricesByYear.push(JSON.parse(JSON.stringify(currentYearInfo)))
  }

  return pricesByYear
}

//-------------------------------------------------------------------
const parsePriceYearlyData = (materialPrices, availableCurrencies) => {
  const pricesByMonth = organisePricesByYear(
    materialPrices,
    availableCurrencies
  )
  return pricesByMonth.map(p => {
    const dt = new Date(parseInt(p.year), 0, 1)
    let price = {
      date: p.year,
      dt: dt.getTime(),
    }

    for (let idx = 0; idx < availableCurrencies.length; idx++)
      price[availableCurrencies[idx].id] = p.avgPrices[idx]
    return price
  })
}

//-------------------------------------------------------------------
export const parsePriceData = (materialPrices, countryCurrencies, locale) => {
  const availableCurrencies = countryCurrencies.map(cc => {
    return {
      id: cc,
      label: cc,
      labelSymbol: getCurrencySymbol(locale, cc),
    }
  })
  return {
    availableCurrencies,
    defaultCurrency: countryCurrencies[0],
    priceList: {
      daily: parsePriceDailyData(materialPrices, availableCurrencies),
      monthly: parsePriceMonthlyData(materialPrices, availableCurrencies),
      yearly: parsePriceYearlyData(materialPrices, availableCurrencies),
    },
  }
}
